import { render, staticRenderFns } from "./catType-add.vue?vue&type=template&id=77f8eb20&scoped=true&"
import script from "./catType-add.vue?vue&type=script&lang=js&"
export * from "./catType-add.vue?vue&type=script&lang=js&"
import style0 from "./catType-add.vue?vue&type=style&index=0&id=77f8eb20&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77f8eb20",
  null
  
)

export default component.exports